import React from "react";
import styles from "./HeroTitle.module.css";

export default function HeroTitle({ nowSvg }) {
  return (
    <h1 className={styles.title}>
      The Future of Metal
      <br /> Manufacturing is <img src={nowSvg} loading="lazy" alt="now" className={styles.nowSvg} />
    </h1>
  );
}
